




































import Analytics from '@/services/Analytics'
import Channel from '@/types/Channel.interface'
import Person from '@/types/Person.interface'
import User from '@/types/User.interface'
import InboxAssignmentSelect from '@/components/InboxAssignmentSelect.vue'
import InboxStatusSwitch from '@/components/InboxStatusSwitch.vue'
import MessagesFilterButton from '@/components/MessagesFilterButton.vue'
import Vue, { PropType } from 'vue'
import Button from '@/types/components/Button.interface'
import moment from 'moment-timezone'
export default Vue.extend({
    components: {
        InboxAssignmentSelect,
        InboxStatusSwitch,
        MessagesFilterButton
    },
    props: {
        channel: {
            type: Object as PropType<Channel>,
            required: true
        },
        person: {
            type: Object as PropType<Person>,
            required: true
        },
        showMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        //  The buttons displayed on the right side the smsMessagePanel toolbar
        messagePanelTools(): Button[] {
            return [
                {
                    tooltip: 'Mark as New',
                    icon: 'bi-exclamation-circle-fill',
                    color: 'primary',
                    callback: () => this.markAsNew()
                },
                {
                    tooltip: 'Print Conversation',
                    icon: 'mdi-printer',
                    color: 'grey darken-1',
                    outlined: true,
                    hidden: this.$vuetify.breakpoint.xsOnly,
                    callback: () => this.startPdf()
                },
                {
                    tooltip: 'View Profile',
                    icon: 'mdi-chevron-double-right',
                    color: 'primary',
                    hidden: this.$vuetify.breakpoint.lgAndUp,
                    callback: () => this.$emit('setStep', 3)
                }
            ]
        },
        users(): User[] {
            return this.$store.getters.users
        }
    },
    methods: {
        //  Mark conversations as nwe
        async markAsNew(): Promise<void> {
            //  Create our payload
            const payload = {
                ...this.channel,
                unread_messages: 1,
                closed: null,
                open: moment.utc().format('YYYY-MM-DD HH:mm:ss')
            }

            //  Send our API request
            await this.$store.dispatch('channelsPut', payload)
        },
        //  Handle the 'assignmentSelected' event InboxAssignmentSelect (add/removes channel assignment)
        onAssignmentSelected(userId: number | null) {
            //  Report the event to Analytics
            Analytics.onInboxAssignmentSelected(this.channel, userId)

            //  Update the channel assignment
            this.channel.assigned_id = userId

            //  If the channel hasn't been set to be open, mark it now
            if (!this.channel.open) this.channel.open = true

            //  Send the changes to the server
            this.$store.dispatch('channelsPut', this.channel)
        },
        //  Pop a conversation create form
        startPdf(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Save Conversation',
                icon: 'mdi-file-pdf',
                color: 'primary',
                component: 'create-pdf',
                props: {
                    start_date: this.channel.created_at,
                    person: this.person
                },
                closeable: true
            })
        }
    }
})
